import React from 'react';
import { Inbox } from '@novu/react';
import { dark } from '@novu/react/themes';
import { useNavigate } from 'react-router';
import { useAuthContext } from '../context/AuthContext';
import { useTheme } from './redux/hooks/useTheme';
 
export function NotificationCenter() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { theme } = useTheme();

  // Ensure a unique subscriber ID is available
  const subscriberId = user?.patientId || user?.email || 'anonymous';
  // Get dark mode state from Redux theme
  const isDarkMode = theme.novu.isDarkMode || theme.mode === 'dark';

  return (
    <Inbox
      applicationIdentifier={process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER || 'default-app'}
      subscriberId={subscriberId}
      apiUrl={process.env.REACT_APP_NOVU_SERVER_URL}
      routerPush={(path) => navigate(path)}
      appearance={{
        baseTheme: isDarkMode ? dark : undefined,
        variables: {
          colorPrimary: '#556ee6',
          borderRadius: '6px'
        },
      }}
    />
  );
}